import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";

import { EvalRunsFilter, SubmitEvalRunPayload } from "../interfaces";

export default {
  // EvalRunsFilter.page is 0-indexed everywhere in this app's Redux state (matching every other
  // domain), but the backend's eval run list endpoint is deliberately 1-indexed AND REQUIRES both
  // page and limit (api/app/shared/schemas/eval.schemas.ts's listEvalRunsQuerySchema) — translate
  // only at this boundary.
  getEvalRuns: (payload: EvalRunsFilter) =>
    request(METHODS.GET, API.EVALUATION.GET_RUNS)({ params: { ...payload, page: payload.page + 1 } }),
  getEvalRun: (uuid: string) => request(METHODS.GET, API.EVALUATION.GET_RUN(uuid))(),
  submitEvalRun: (payload: SubmitEvalRunPayload) => request(METHODS.POST, API.EVALUATION.SUBMIT_RUN)(payload),
  deleteEvalRun: (uuid: string) => request(METHODS.DELETE, API.EVALUATION.DELETE_RUN(uuid))(),
  getEvalDatasets: () => request(METHODS.GET, API.EVALUATION.GET_DATASETS)(),
};
